import React from "react";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

const hasValue = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim() !== "";
  return true;
};

const filterColumnsWithValues = (rows = []) => {
  if (!Array.isArray(rows) || rows.length === 0) return [];

  const keys = Object.keys(rows[0] || {});
  const keysWithValues = keys.filter((key) => rows.some((row) => hasValue(row?.[key])));

  return rows.map((row) => {
    const filteredRow = {};
    keysWithValues.forEach((key) => {
      filteredRow[key] = row?.[key];
    });
    return filteredRow;
  });
};

const ExportExcelWidget = ({ excelData, fileName, onlyColumnsWithValues = false }) => {
  const file_type = "";
  const file_extension = ".xlsx";

  const exportToExcel = async (fileName) => {
    const dataToExport = onlyColumnsWithValues
      ? filterColumnsWithValues(excelData)
      : excelData;

    if (!dataToExport || dataToExport.length === 0) return;

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: file_type });
    FileSaver.saveAs(data, fileName + file_extension);
  };
  return (
    <>
      <CommonButton
        onClick={() => {
          if (excelData.length == 0) return;
          exportToExcel(fileName);
        }}
      >
        Excel Export
      </CommonButton>
    </>
  );
};
export default ExportExcelWidget;
